export const projectCategories = [
  { key: "all", title: "All Projects" },

  { key: "residentialHousing", title: "Housing Projects" },

  { key: "hospitalityHealthcare", title: "Hotels & Hospitals" },

  { key: "corporateOffices", title: "Corporate & Office Projects" },

  { key: "retailCommercial", title: "Retail & Shopping Mall Projects" },

  { key: "industrialWarehousing", title: "Warehouses & Industrial Projects" },

  { key: "solarEnergy", title: "Solar Energy Projects" },

  { key: "urbanDevelopment", title: "Township & City Development Projects" },

  { key: "airportProjects", title: "Airport Infrastructure Projects" },

  { key: "atomicEnergy", title: "Atomic Energy Projects" },

  { key: "expoCentre", title: "Expo & Convention Centre Projects" }
];

export const projects = [

  /* =========================
     HOUSING PROJECTS
  ========================== */

  {
    id: 1,
    title: "Army Welfare Housing Organization",
    category: "residentialHousing",
    location: "Chimbel, Goa",
    lat: 16.0,
    lng: 73.87,
    value: "₹150.00 Lakhs",
    type: "Electrical",
    period: "2007–08",
    images: [
      "/project-images/awho1.jpg",
      "/project-images/awho2.jpg"
    ],
    description: [
      `Army Welfare Housing Organization entrusted us with the execution of <strong>internal electrical works</strong> for its <strong>premium residential township villas</strong> located at Chimbel, Goa.`,
      `The scope included <strong>SITC of complete internal electrical systems</strong>, ensuring safe power distribution, premium-quality workmanship, and long-term operational reliability aligned with residential standards.`
    ]
  },

  {
    id: 2,
    title: "DLF – The Magnolias",
    category: "residentialHousing",
    location: "Gurgaon, India",
    regionLabel: "Delhi-NCR, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹65.00 Lakhs",
    type: "Electrical",
    period: "2012",
    images: [
      "/project-images/DLFMagnolias.avif",
      "/project-images/DLFMagnolias.webp"
    ],
    description: [
      `DLF entrusted us with <strong>internal electrification works</strong> for <strong>The Magnolias</strong>, a premium residential development in Gurgaon.`,
      `The scope included <strong>SITC of internal electrical installations</strong>, covering wiring, fixtures, and associated systems executed to meet high-end residential quality and safety standards.`
    ]
  },

  {
    id: 3,
    title: "Supertech – C-Zar Suites",
    category: "residentialHousing",
    location: "Greater Noida, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹55.00 Lakhs",
    type: "Electrical",
    period: "2010–12",
    images: [
      "/project-images/supertech1.jpg",
      "/project-images/supertech2.webp"
    ],
    description: [
      `Supertech entrusted us with <strong>internal electrical works</strong> for its premium residential project, C-Zar Suites.`,
      `The scope comprised <strong>SITC of complete internal electrical infrastructure</strong>, ensuring reliable power supply and compliance with modern residential safety requirements.`
    ]
  },

  {
    id: 4,
    title: "Ansal – Aquapolis",
    category: "residentialHousing",
    location: "Ghaziabad, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹80.00 Lakhs",
    type: "Electrical",
    period: "2011–12",
    images: [
      "/project-images/ansal1.avif",
    ],
    description: [
      `Ansal Properties entrusted us with <strong>internal electrification works</strong> for Aquapolis residential development.`,
      `The scope included <strong>SITC of internal electrical systems and equipment</strong>, executed with a focus on safety, efficiency, and dependable long-term performance.`
    ]
  },

  /* =========================
     HOTELS & HOSPITALS
  ========================== */

  {
    id: 5,
    title: "The Ashoka Hotel",
    category: "hospitalityHealthcare",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹40.00 Lakhs",
    type: "Electrical",
    period: "2008–09",
    images: [
      "/project-images/ashokahotel1.jpg",
      "/project-images/ashokahotel2.jpg"
    ],
    description: [
      `The Ashoka Hotel entrusted us with <strong>internal electrical works</strong> for its Fashion Bar Studio.`,
      `The scope included <strong>lighting systems, wiring, fixtures, and associated electrical installations</strong>, meeting premium hospitality operational standards.`
    ]
  },

  {
    id: 6,
    title: "Apollo Hospitals",
    category: "hospitalityHealthcare",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹26.00 Lakhs",
    type: "Electrical",
    period: "2007–08",
    images: [
      "/project-images/apollo1.webp",
    ],
    description: [
      `Apollo Hospitals entrusted us with <strong>internal electrical renovation works</strong> for critical healthcare departments.`,
      `The scope involved <strong>SITC of electrical systems</strong>, ensuring uninterrupted power distribution and safe hospital operations.`
    ]
  },

  {
    id: 7,
    title: "Fraser Suites",
    category: "hospitalityHealthcare",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹116.00 Lakhs",
    type: "Electrical + Mechanical",
    period: "2011–12",
    images: [
      "/project-images/fraser1.jpg"
    ],
    description: [
      `Fraser Suites entrusted us with the execution of <strong>complete electrical and mechanical works</strong> for its hospitality facility.`,
      `The scope included <strong>SITC of LED lighting, gas bank systems, and integrated MEP services</strong>, delivering a high-performance hospitality solution.`
    ]
  },

  {
    id: 8,
    title: "Cube Stop – HADPL",
    category: "hospitalityHealthcare",
    location: "Madhya Pradesh, India",
    lat: 23.26,
    lng: 77.41,
    value: "₹200.00 Lakhs",
    type: "MEP",
    period: "2021–22",
    images: [
      "/project-images/cubestop1.jpg"
    ],
    description: [
      `Cube Stop entrusted us with <strong>comprehensive MEP works</strong> for its hospitality development.`,
      `The scope included <strong>electrical installations, mechanical systems, and associated infrastructure</strong>, executed to modern hospitality operational standards.`
    ]
  },

  /* =========================
     CORPORATE PROJECTS
  ========================== */

  {
    id: 9,
    title: "AICTE Office",
    category: "corporateOffices",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹60.00 Lakhs",
    type: "Electrical",
    period: "2007",
    images: [
      "/project-images/aicte1.jpg",
      "/project-images/aicte2.avif",
    ],
    description: [
      `AICTE entrusted us with <strong>internal electrical works</strong> for its office premises.`,
      `The scope included <strong>wiring, lighting, LT cabling, panels, and complete electrical infrastructure</strong>, ensuring safe and efficient corporate operations.`
    ]
  },

  {
    id: 10,
    title: "Consulate General of Canada",
    category: "corporateOffices",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹30.00 Lakhs",
    type: "Electrical",
    period: "2007",
    images: [
      "/project-images/consultate1.avif"
    ],
    description: [
      `The Consulate General of Canada entrusted us with <strong>internal electrical infrastructure works</strong> for its diplomatic office.`,
      `The scope included <strong>power distribution, lighting systems, and structured cabling</strong>, executed in compliance with institutional standards.`
    ]
  },

  {
    id: 11,
    title: "APL Logistics Office",
    category: "corporateOffices",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹85.00 Lakhs",
    type: "Interior + MEP",
    period: "2012–13",
    images: [
      "/project-images/apl1.jpg"
    ],
    description: [
      `APL Logistics entrusted us with <strong>interior and MEP works</strong> for its corporate office facility.`,
      `The scope included <strong>electrical, mechanical, and interior infrastructure</strong>, ensuring modern and efficient workspace functionality.`
    ]
  },

  {
    id: 12,
    title: "Maruti Suzuki – VIP Office",
    category: "corporateOffices",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹405.00 Lakhs",
    type: "Electrical",
    period: "2007–08",
    images: [
      "/project-images/maruti1.avif",
      "/project-images/maruti2.jpg"
    ],
    description: [
      `Maruti Suzuki entrusted us with <strong>high-end internal electrical works</strong> for its Corporate VIP Office.`,
      `The scope included <strong>premium lighting systems, distribution panels, UPS provisions, and complete electrical infrastructure</strong>, aligned with executive workspace standards.`
    ]
  },

  {
    id: 13,
    title: "Reliance Industries – Jio Centre (Phase 1)",
    category: "corporateOffices",
    location: "Gwalior, India",
    lat: 26.22,
    lng: 78.18,
    value: "₹250.00 Lakhs",
    type: "Interior + MEP",
    period: "2014",
    images: [
      "/project-images/jio1.avif"
    ],
    description: [
      `Reliance Industries entrusted us with <strong>interior and MEP works</strong> for the Jio Centre.`,
      `The scope included <strong>internal electrification, lighting systems, power distribution, HVAC, cabling</strong>, and the <strong>supply, installation, testing, and commissioning of complete MEP infrastructure.</strong>`
    ]
  },
  {
    id: 24,
    title: "Reliance Industries – Jio Centre (Phase 2)",
    category: "corporateOffices",
    location: "Gwalior, India",
    lat: 26.22,
    lng: 78.18,
    value: "₹70.00 Lakhs",
    type: "Interior + MEP",
    period: "2016",
    images: [
      "/project-images/jio1.avif"
    ],
    description: [
      `Phase–2 of the Jio Centre project involved <strong>interior and MEP works</strong> for the Jio Centre.`,
      `The scope included <strong>electrical installations, lighting, power cabling, HVAC services</strong>, and the <strong> supply, installation, testing, and commissioning of MEP systems.</strong>`
    ]
  },

  /* =========================
     RETAIL
  ========================== */

  {
    id: 14,
    title: "Future Group – Big Bazaar",
    category: "retailCommercial",
    location: "PAN India",
    lat: 22.0,
    lng: 78.5,
    value: "₹915.00 Lakhs",
    type: "Electrical",
    period: "2009–18",
    images: [
      "/project-images/future1.jpg",
    ],
    description: [
      `Future Group entrusted us with <strong>electrical works across multiple Big Bazaar stores</strong> nationwide.`,
      `The scope included <strong>internal electrification, LT panels, lighting systems, and power distribution</strong>, ensuring consistent retail infrastructure standards across locations.`
    ]
  },

  {
    id: 15,
    title: "Pantaloons – Aditya Birla Group",
    category: "retailCommercial",
    location: "PAN India",
    lat: 21.5,
    lng: 79.5,
    value: "₹330.00 Lakhs",
    type: "Electrical",
    period: "2009–18",
    images: [
      "/project-images/pantaloons1.jpg",
      "/project-images/pantaloons2.jpg"
    ],
    description: [
      `Pantaloons entrusted us with <strong>electrical works for retail stores</strong> across India.`,
      `The scope included <strong>store lighting, wiring, distribution panels, and SITC of electrical systems</strong>, ensuring operational reliability for organized retail environments.`
    ]
  },

  {
    id: 16,
    title: "The Celebration Mall",
    category: "retailCommercial",
    location: "Amritsar, India",
    lat: 31.63,
    lng: 75.1,
    value: "₹95.00 Lakhs",
    type: "MEP",
    period: "2011–12",
    images: [
      "/project-images/celebration1.jpg",
      "/project-images/celebration2.jpg"
    ],
    description: [
      `The Celebration Mall entrusted us with <strong>MEP works</strong> for its retail infrastructure.`,
      `The scope included <strong>electrical installations, mechanical systems, and associated infrastructure</strong>, supporting modern mall operations.`
    ]
  },

  {
    id: 17,
    title: "DMart – Palm Garden",
    category: "retailCommercial",
    location: "Ludhiana, India",
    lat: 30.91,
    lng: 75.86,
    value: "₹115.00 Lakhs",
    type: "Electrical",
    period: "2023–24",
    images: [
      "/project-images/dmart1.avif"
    ],
    description: [
      `DMart entrusted us with <strong>internal electrical works</strong> for its Palm Garden retail outlet.`,
      `The scope included <strong>power distribution systems, lighting installations, and electrical infrastructure</strong>, ensuring seamless retail operations.`
    ]
  },

  /* =========================
     SOLAR
  ========================== */

  {
    id: 18,
    title: "6 MW Solar Power Plant",
    category: "solarEnergy",
    location: "Telangana, India",
    lat: 17.50,
    lng: 78.50,
    value: "₹22.00 Lakhs",
    type: "DC Electrical Works",
    period: "2016",
    images: [
      "/project-images/solar1.webp"
    ],
    description: [
      `The 6 MW solar power project entrusted us with <strong>DC-side electrical works</strong> for the plant.`,
      `The scope included <strong>cable laying, inverter connections, transformer installations, and earthing systems</strong>, ensuring system safety and performance reliability.`
    ]
  },

  {
    id: 19,
    title: "4.4 MW Solar Power Plant (M&M)",
    category: "solarEnergy",
    location: "Telangana, India",
    lat: 17.35,
    lng: 78.65,
    value: "₹5.00 Lakhs",
    type: "AC + DC Electrical Works",
    period: "2016",
    images: [
      "/project-images/solar1.webp"
    ],
    description: [
      `The 4.4 MW solar plant entrusted us with <strong>AC and DC electrical works</strong> for power evacuation infrastructure.`,
      `The scope included <strong>cabling, inverter systems, transformers, and complete earthing installations</strong>, ensuring safe grid integration.`
    ]
  },

  /* =========================
     AIRPORT
  ========================== */

  {
    id: 20,
    title: "Delhi International Airport – T3",
    category: "airportProjects",
    location: "New Delhi, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹10.50 Lakhs",
    type: "Electrical (Labour)",
    period: "2011",
    images: [
      "/project-images/delhiairport1.avif"
    ],
    description: [
      `Delhi International Airport entrusted us with <strong>electrical labour works</strong> for Terminal 3.`,
      `The scope included <strong>installation support for power distribution and lighting systems</strong>, contributing to critical airport infrastructure execution.`
    ]
  },

  {
    id: 21,
    title: "Chitrakoot Airport – Terminal Building",
    category: "airportProjects",
    location: "Chitrakoot, India",
    lat: 25.20,
    lng: 80.88,
    value: "₹345.00 Lakhs",
    type: "MEP",
    period: "2019–22",
    images: [
      "/project-images/chitrakoot1.jpg"
    ],
    description: [
      `Chitrakoot Airport entrusted us with <strong>comprehensive MEP works</strong> for its Terminal Building.`,
      `The scope included <strong>complete electrification, DG sets, LT panels, fire-fighting systems, and HVAC installations</strong>, ensuring reliable airport operations.`
    ]
  },

  {
    id: 22,
    title: "Maharaja Bir Bikram Airport",
    category: "airportProjects",
    location: "Agartala, India",
    lat: 23.89,
    lng: 90.4,
    value: "₹153.00 Lakhs",
    type: "Electrical",
    period: "2023–24",
    images: [
      "/project-images/mbb1.jpg"
    ],
    description: [
      `MBB Airport entrusted us with <strong>critical electrical infrastructure works</strong> for enhanced operational reliability.`,
      `The scope included <strong>LT cabling, panels, ring main systems, and earthing installations</strong>, ensuring uninterrupted airport services.`
    ]
  },
  {
    id: 25,
    title: "Vijayawada Airport – AAI",
    category: "airportProjects",
    location: "Vijayawada, India",
    lat: 16.51,
    lng: 80.1,
    value: "₹106.00 Lakhs",
    type: "Electrical",
    period: "2022–23",
    images: [
      "/project-images/vijayawada1.jpg"
    ],
    description: [
      `AAI Vijayawada Airport entrusted us with <strong>ring main electrical distribution works,</strong> aimed at improving redundancy and reliability of power supply across airport facilities.`,
      `The scope included <strong>SITC of ring main system</strong>,  (closed-loop LT distribution ensuring uninterrupted power), supply and installation of <strong> electrical panels, LT electrical cables, SDP pipes laid through HDD drilling, and SITC of digital earthing systems </strong> for enhanced electrical safety.`
    ]
  },
  {
    id: 26,
    title: "Trivandrum Airport - AAI",
    category: "airportProjects",
    location: "Trivandrum, India",
    lat: 9.60,
    lng: 76.6,
    value: "₹35.14 Lakhs",
    type: "Electrical Works",
    period: "2018",
    images: [
      "/project-images/trivandrum1.jpg"
    ],
    description: [
      `AAI Trivandrum entrusted us with <strong>supply, installation, testing, and commissioning of LED lighting systems</strong> for both <strong>external and internal airport areas</strong>, aimed at improving illumination efficiency and reducing energy consumption.`,
    ]
  },
  {
    id: 27,
    title: "Kangra Airport – AAI",
    category: "airportProjects",
    location: "Kangra, India",
    lat: 32.1606,
    lng: 76.5634,
    value: "₹85.00 Lakhs",
    type: "Electrical Works",
    period: "2022",
    images: [
      "/project-images/kangra1.jpg"
    ],
    description: [
      `Kangra Airport entrusted us with the execution of <strong> perimeter lighting works</strong> for enhanced security and visibility.`,
      `The scope included<strong> SITC of 400 perimeter lights</strong> installation of <strong> light brackets, and electrical provisions for CCTV systems</strong> associated with the airport <strong>CNS infrastructure,</strong> strengthening both illumination and surveillance readiness.`
    ]
  },

  /* =========================
     ATOMIC ENERGY
  ========================== */

  {
    id: 23,
    title: "Nuclear Fuel Complex",
    category: "atomicEnergy",
    location: "Hyderabad, India",
    lat: 17.44,
    lng: 78.44,
    value: "₹173.00 Lakhs",
    type: "Electrical",
    period: "2023–24",
    images: [
      "/project-images/nfc1.jpg"
    ],
    description: [
      `Nuclear Fuel Complex entrusted us with <strong>Supply, Installation, Testing, and Commissioning (SITC)</strong> of electrical infrastructure for its <strong> ATMF plant </strong>.`,
      `The scope of work comprised <strong>SITC of main electrical distribution panels</strong>, complete <strong>LT electrical cabling</strong>, and associated electrical accessories required for reliable power distribution within the plant. All works were executed in accordance with stringent <strong>industrial safety standards</strong>, ensuring system reliability, operational continuity, and long-term performance.`,
      `The project was successfully delivered to support <strong>safe plant operations, controlled power distribution, and dependable electrical infrastructure</strong> within a high-security nuclear facility environment.`
    ]
  },
  {
    id: 28,
    title: "PGI Chandigarh",
    category: "hospitalityHealthcare",
    location: "Chandigarh, India",
    lat: 30.7333,
    lng: 76.7794,
    value: "₹250.00 Lakhs",
    type: " Electrical, HVAC & Civil Works",
    period: "2025–26",
    images: [
      "/project-images/pgi1.webp",
    ],
    description: [
      `PGI Chandigarh, recognized as one of Asia’s leading hospitals and located in Sector 12, Chandigarh, entrusted us with critical electrical infrastructure works.`,
      `The scope of work included the <strong>Supply, Installation, Testing, and Commissioning (SITC)</strong> of two (2) <strong>UPS systems of 160 kVA each</strong>, along with:<ul style="list-style-type: disc; padding-left: 1.5rem; margin-top: 0.5rem;"><li>Provision and development of a dedicated UPS room</li><li>Installation of bus duct rising main</li><li>Complete power distribution system up to the utility points</li></ul>`,
      `The project was designed to strengthen the institute’s reliable and uninterrupted power supply infrastructure for essential medical operations.`
    ]
  },
  {
    id: 29,
    title: "Bhabha Atomic Research Centre (NRB) ",
    category: "atomicEnergy",
    location: "Tarapur, Mumbai",
    lat: 19.84,
    lng: 72.85,
    value: "₹249.35 Lakhs",
    type: "Electrical & Surveillance Systems",
    period: "2025–26",
    images: [
      "/project-images/nrb1.png"
    ],
    description: [
      `NRB, BARC, Tarapur entrusted us with the execution of <strong>electrical and security infrastructure works</strong> for enhanced safety and monitoring across the facility.`,
      `The scope of work includes the <strong>supply, installation, testing, and commissioning of PLIDC street lighting systems, street light poles, electrical cabling, and fiber-optic-based security camera systems</strong>integrated with <strong>LT electrical cabling</strong> NVRs and cloud-based camera management.`,
      `The project focuses on improving <strong>illumination, surveillance coverage, and centralized monitoring,</strong> in line with high-security institutional requirements`
    ]
  },
  {
    id: 30,
    title: "Nuclear Power Corporation of India Limited (NPCIL)",
    category: "atomicEnergy",
    location: "Kota, Rajasthan",
    lat: 25.2138,
    lng: 75.8648,
    value: "₹176.62 Lakhs",
    type: "Electrical Works",
    period: "2025–26",
    images: [
      "/project-images/npcil1.jpg"
    ],
    description: [
      `NPCIL, Kota entrusted us with the execution of <strong>complete electrification works</strong> of its residential township, including <strong>Anukiran and Anuchhaya Colonies</strong>.`,
      `The scope of work includes electrification of the NPCIL township through the setup of <strong>main feeder pillars, sub-feeder pillars, electrical distribu on boards for individual housing units, street lightening systems,</strong>extensive <strong> electrical cabling, and re-establishment of the earthing system. </strong>`,
      `The project is designed to ensure <strong>safe power distribution, operational reliability, and longterm electrical safety</strong>  across the residential infrastructure.`
    ]
  },
  {
    id: 31,
    title: "Nuclear Fuel Complex (ZC)",
    category: "atomicEnergy",
    location: "Tuticorin",
    lat: 9.4874,
    lng: 78.1200,
    value: "₹101.89 Lakhs",
    type: "Electrical Works",
    period: "2025–26",
    images: [
      "/project-images/nfc1.jpg"
    ],
    description: [
      `Nuclear Fuel Complex (ZC), Tuticorin entrusted us with the execution of comprehensive <strong>electrical infrastructure works </strong> for township and community facilities. `,
      `The scope of work includes the <strong> supply, installation, testing, and commissioning (SITC) of sports high-mast lighting, area high-mast lighting, street lighting for the township, complete electrification of the community center, SITC of AMF panels, installation of feeder pillars for lighting, and associated electrical cabling works. </strong>`,
      `The project is aimed at enhancing <strong>safe, reliable, and efficient electrical infrastructure</strong> for residential and community use.`
    ]
  },
  {
    id: 32,
    title: "Bhopal Airport (Rajabhoj)",
    category: "airportProjects",
    location: "Bhopal, Madhya Pradesh",
    lat: 23.2599,
    lng: 77.4085,
    value: "₹57.82 Lakhs",
    type: "Electrical & Fire Fighting Works",
    period: "2025",
    images: [
      "/project-images/bhopal1.jpg"
    ],
    description: [
      `Bhopal Airport entrusted us with the execution of electrical and fire-fighting infrastructure works for its fire station and associated facilities, aimed at strengthening safety, reliability, and operational readiness.`,
      `The scope of work included the <strong>Supply, Installation, Testing, and Commissioning</strong> of:<ul style="list-style-type: disc; padding-left: 1.5rem; margin-top: 0.5rem;"><li>Main electrical cables and main electrical panels</li><li>Internal and external fire station lighting</li><li>Ceiling fans and ventilation systems</li><li>RO water cooler system</li><li>Fire alarm system</li><li>Complete fire pump room setup with control pumps </li><li>Area street lighting for the fire station building</li></ul>`,
      `The project is designed to enhance electrical reliability, fire safety preparedness, and overall infrastructure efficiency, in compliance with airport safety standards.`,
    ]
  },
  {
    id: 33,
    title: "Puducherry Airport",
    category: "airportProjects",
    location: "Puducherry",
    lat: 11.9416,
    lng: 79.6083,
    value: "₹177 Lakhs",
    type: "Airfield Ground Lighting (AGL) & Power Systems ",
    period: "2025",
    images: [
      "/project-images/puducherry1.jpg"
    ],
    description: [
      `Puducherry Airport entrusted us with the execution of specialized airfield ground lighting and electrical infrastructure works aimed at enhancing operational safety and night-landing capabilities. `,
      `The scope of work included the <strong>supply, installation, testing, and commissioning of GLF lighting systems, runway edge lighting (inset type), glide path signage, wind cone system, perimeter lighting, constant current regulator (CCR) systems, and a mobile DG set with light tower.</strong>`,
      `The project is designed to ensure safe aircraft operations, improved navigational visibility, and reliable power backup, in line with aviation safety requirements`,
    ]
  },
  {
    id: 34,
    title: "Tezpur Airport",
    category: "airportProjects",
    location: "Tezpur, Assam",
    lat: 26.7083,
    lng: 91.5850,
    value: "₹112.10 Lakhs",
    type: "Electrical Works ",
    period: "2022-27",
    images: [
      "/project-images/tezpur1.webp"
    ],
    description: [
      `Tezpur Airport entrusted us with the execution of <strong>major electrical infrastructure renovation and power backup enhancement works</strong>  to ensure reliable and uninterrupted airport operations.`,
      `The scope of work includes renovation of the <strong> electrical substation, replacement of DG sets comprising two (2) numbers of 250 kVA and one (1) number of 62.5 kVA units complete with AMF panels, replacement of the 11 kV HT panel along with allied electrical cables and associated electrical works, and comprehensive Annual Maintenance Contract (AMC) of the DG sets for a period of five (5) years.</strong>`,
      `The project is structured to deliver <strong> long-term power reliability, operational safety, and efficient maintenance support,</strong> aligned with airport electrical and safety standards.`,
    ]
  },
  {
    id: 35,
    title: "Dibrugarh Airport",
    category: "airportProjects",
    location: "Dibrugarh, Assam",
    lat: 27.4833,
    lng: 93.1,
    value: "₹29.50 Lakhs",
    type: "Electrical Works – Digital Canopy Lighting  ",
    period: "2024-26",
    images: [
      "/project-images/dibrugarh1.jpg"
    ],
    description: [
      `Dibrugarh Airport entrusted us with the execution of <strong>digital-type canopy lighting works to enhance illumination, visibility, and the overall passenger experience</strong> at the terminal frontage.`,
      `The scope of work includes <strong>supply, installation, testing, and commissioning of advanced digital canopy lighting systems, designed to improve aesthetics, energy efficiency, and operational reliability </strong> in line with modern airport infrastructure standards.`,
    ]
  },
  {
    id: 45,
    title: "DS Group – Anandam",
    category: "hospitalityHealthcare",
    location: "Greater Noida, Uttar Pradesh ",
    lat: 28.61,
    lng: 77.20,
    value: "₹394.00 Lakhs",
    type: "MEP Works",
    period: "2021-22",
    images: [
      "/project-images/anandam1.jpg"
    ],
    description: [
      `Anandam by DS Group, Greater Noida entrusted us with<strong>comprehensive MEP execution</strong> for its premium development.`,
      `The scope of work includes <strong> SITC of internal electrification, fire-fighting systems including pump room, ventilation and pressurization systems, plumbing, and drainage systems, </strong>ensuring integrated building services aligned with modern safety and operational standards.`,
    ]
  },

  /* =========================
     INDUSTRIAL & WAREHOUSING PROJECTS
  ========================== */

  {
    id: 36,
    title: "Nax World – Power Audit Rectification",
    category: "industrialWarehousing",
    location: "India",
    value: "₹55.00 Lakhs",
    type: "Electrical",
    images: [],
    description: []
  },

  {
    id: 37,
    title: "IM Ghaziabad & Gurgaon – Electrical & FAS Work",
    category: "industrialWarehousing",
    location: "Ghaziabad & Gurgaon, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹45.00 Lakhs",
    type: "Electrical & Fire Alarm System",
    images: [],
    description: []
  },

  {
    id: 38,
    title: "IM Ghaziabad & Gurgaon (Naurangpur) – MEP Work",
    category: "industrialWarehousing",
    location: "Ghaziabad & Gurugram, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹172.00 Lakhs",
    type: "MEP",
    images: [],
    description: []
  },

  {
    id: 39,
    title: "IM Ghaziabad & Jaipur – Electrical & FAS Work",
    category: "industrialWarehousing",
    location: "Ghaziabad & Jaipur, India",
    lat: 26.9124,
    lng: 75.7873,
    value: "₹52.00 Lakhs",
    type: "Electrical & Fire Alarm System",
    images: [],
    description: []
  },

  {
    id: 40,
    title: "V3S Foods (DS Group) – MEP Works",
    category: "industrialWarehousing",
    location: "India",
    value: "₹130.00 Lakhs",
    type: "MEP",
    images: [],
    description: []
  },

  {
    id: 41,
    title: "ITC Ltd. – Electrical Works",
    category: "industrialWarehousing",
    location: "Haridwar, Uttarakhand",
    lat: 29.9457,
    lng: 78.1642,
    value: "₹3.00 Lakhs",
    type: "Electrical",
    images: [],
    description: []
  },

  {
    id: 42,
    title: "SRI Ranbaxy Ltd. – Fire System",
    category: "industrialWarehousing",
    location: "Gurgaon & Mumbai, India",
    lat: 28.61,
    lng: 77.20,
    value: "₹25.00 Lakhs",
    type: "Fire System",
    images: [],
    description: []
  },

  {
    id: 43,
    title: "P&G Factory – Electrofitting Works",
    category: "industrialWarehousing",
    location: "Baddi, Himachal Pradesh",
    lat: 30.9539,
    lng: 76.7996,
    value: "₹25.00 Lakhs",
    type: "Electrical",
    images: [],
    description: []
  },

  {
    id: 44,
    title: "Touchwood Factory Complex – IMT Manesar",
    category: "industrialWarehousing",
    location: "IMT Manesar, Gurugram",
    lat: 28.61,
    lng: 77.20,
    value: "₹80.00 Lakhs",
    type: "Interior & MEP",
    images: [],
    description: []
  },
];

